import React from "react";
import * as R from "ramda";
import { format } from "date-fns";
import { css } from "glamor";

const styles = {
    authActivityText: css({
        lineHeight: "32px !important",
        height: "64px",
        display: "flex",
        alignItems: "center",
    }),
};

type IProps = {
    auth: { displayName: string; is_admin: boolean; username: string };
    users: Array<{ authActivity: { timestamp: string } }>;
};

export default ({ auth, users }: IProps) => {
    let messagePartWithDate = "";
    if (!auth.is_admin) {
        const currentUser = R.find(R.propEq("username", auth.username))(users);
        const [, previousLogin] = currentUser.authActivity;
        if (previousLogin === undefined)
            messagePartWithDate = ", this is your first time logging in";
        else {
            const date = new Date(previousLogin.timestamp);
            const time_str = format(date, "H:mm [GMT]Z");
            const date_str = format(date, "DD MMM YYYY");
            messagePartWithDate = `, you last logged in at ${time_str} on ${date_str}`;
        }
    }

    return (
        <div className={`${styles.authActivityText}`}>
            {`Welcome ${auth.displayName}${messagePartWithDate}.`}
        </div>
    );
};
